import { motion } from "framer-motion";
import { Database, ScanLine, BadgeCheck, Lock } from "lucide-react";
import { WHY } from "../../data/content";
import { Reveal } from "./Reveal";
import { BrandLabel } from "./BrandLabel";

const ICONS = [Database, ScanLine, BadgeCheck, Lock];

const renderRich = (text) =>
  text.split(/(WhatThe\? Food|WhatThe\? Body)/g).map((part, i) => {
    if (part === "WhatThe? Food")
      return (
        <span key={i}>
          WhatThe<span style={{ color: "#F97316" }}>?</span> Food
        </span>
      );
    if (part === "WhatThe? Body")
      return (
        <span key={i}>
          WhatThe<span style={{ color: "#8B5CF6" }}>?</span> Body
        </span>
      );
    return part;
  });


export const WhyWhatThe = () => (
  <section id="why" className="relative py-20 md:py-28 bg-white border-y border-line">
    <div className="mx-auto max-w-[1240px] px-5 md:px-8">
      <div className="max-w-2xl mb-14">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-slate mb-3">
            Why WhatThe?
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-ink leading-[1.1]">
            Built differently to traditional ingredient scanners
          </h2>
          <p className="mt-4 text-[15px] md:text-base text-slate leading-relaxed">
            <BrandLabel text="Most scanning apps only read barcodes and lock you into a monthly subscription. WhatThe? Scan covers more, charges once and respects your privacy." />
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {WHY.map((w, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={w.title}
              data-testid={`why-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="rounded-3xl bg-page border border-line p-6 shadow-soft"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-food-bg">
                <Icon className="h-5 w-5 text-food-accent" strokeWidth={1.8} />
              </div>
              <h3 className="mt-4 text-lg font-bold tracking-tight text-ink">{w.title}</h3>
              {w.body.split("\n\n").map((para, pi) => (
                <p
                  key={pi}
                  className={`text-[15px] leading-relaxed text-slate ${pi === 0 ? "mt-2" : "mt-3"}`}
                >
                  {renderRich(para)}
                </p>
              ))}
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
